'use client';

import { useEffect } from 'react';
import { trackMixpanelEvent } from '@/lib/utils/trackEvent';
import { MixpanelEvent, MixpanelEventDataMap } from '@/constant/mixpanelEvent';

interface ServerTrackerProps {
  mixpanelEvent: MixpanelEvent;
  mixpanelEventData?: MixpanelEventDataMap[keyof MixpanelEventDataMap];
}

/**
 * 服务端埋点组件 - 用于在服务端组件中触发客户端埋点
 * 这个组件会在客户端挂载时自动触发埋点事件
 */
export default function ServerTracker({ mixpanelEvent, mixpanelEventData }: ServerTrackerProps) {
  useEffect(() => {
    trackMixpanelEvent(mixpanelEvent, mixpanelEventData);
  }, [mixpanelEvent, mixpanelEventData]);

  // 不渲染任何内容
  return null;
}
